import {GLOBAL} from "./globals";

export function generateUuid(): string {
    return GLOBAL.window().crypto.randomUUID();
}

export function fnv32Hash(value: string): string {
    // eslint-disable-next-line no-bitwise
    let hash = 0x811c9dc5 >>> 0;
    for (let i = 0; i < value.length; i++) {

        // eslint-disable-next-line no-bitwise
        hash ^= value.codePointAt(i) || 0;

        // eslint-disable-next-line no-bitwise
        hash = Math.imul(hash, 16777619) >>> 0;
    }
    // eslint-disable-next-line no-bitwise
    return (hash >>> 0).toString(16).padStart(8, "0");
}